define([
    'text!index2021-base-line/component/page-content.html',
    'index2021-base-line/common/api',
    'jquery',
    '../common/utils',
    'index2021-base-line/component/swiper-title',
    'index2021-base-line/component/product-list',

    'css!index2021-base-line/component/page-content.css'
], function(
    tpl,
    Api,
    $,Utils,
    SwiperTitle,
    ProductList
){
    return {
        components: {
            SwiperTitle: SwiperTitle,
            ProductList: ProductList
        },
        template: tpl,
        data: function(){
            return {
                isPC: true,
                baseTitle: 's20480_1629787919_4828.png',
                baseCon: 's20480_1629788946_2456.png',
                baseList: ['s20480_1629790832_1932.png','s20480_1629790981_5151.png','s20480_1629791039_8607.png'],
                baseTitlePhone: 's20480_1629969161_8286.png',
                baseConPhone: 's20480_1629969233_1830.png',
                baseListPhone: ['s20480_1629969285_3275.png','s20480_1629969308_8754.png','s20480_1629969324_2699.png'],
                baseWidth: 0,
                baseHeight: 0,
                baseConWidth: 0,
                productList: [],
                ridgeNum: 16,
                productWidth: 0
            };
        },
        methods: {
            init: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    obj.isPC = true;
                }
                obj.getWidth();
                obj.getImages();
            },
            getWidth: function () {
                var obj = this;
                if(obj.isPC){
                    obj.productWidth = ($(window).width()-150)/4;
                    obj.baseConWidth = $(window).width()*94/100;
                    obj.baseWidth = obj.baseConWidth*600/1440;
                    obj.baseHeight = obj.baseWidth/600*752;
                }else {
                    obj.productWidth = 320;
                }
            },
            getImages: function () {
                var _this = this;
                Api.highListApi.ajax()
                    .done(function(data){
                        _this.productList = data.base;
                    });
            }
        },
        mounted: function(){
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                obj.getWidth();
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-base-line/component/page-content.js
// module id = 187
// module chunks = 11